<div class="items-header-bar">
  <div class="header-left">
    <ng-container><h3>Categories:</h3></ng-container>
    <div class="category-actio-buttons">
      <ng-container *ngIf="!isCategoryEditMode">
        <button kendoButton themeColor="primary" (click)="onEditCategories()">
          Edit
        </button>
      </ng-container>
      <ng-container *ngIf="isCategoryEditMode">
        <button kendoButton themeColor="error" (click)="onCancelCategories()">
          Cancel
        </button>
        <button kendoButton themeColor="success" (click)="onSaveCategories()">
          Save
        </button>
      </ng-container>

      <button
        kendoButton
        themeColor="primary"
        icon="plus"
        (click)="onClickAddCategory()"
      >
        <fa-icon class="icon-text" [icon]="['fas', 'plus']"></fa-icon>Add
        Category
      </button>
    </div>
  </div>
  <div class="header-center">
    <ng-container *ngIf="selectedCategory?.name">
      <h3>
        Selected Category:
        <span class="highlight">{{ selectedCategory?.name }}</span>
      </h3>
    </ng-container>
  </div>
  <div class="header-right">
    <ng-container
      *ngIf="!isEditMode && selectedCategory && assignedItems?.data?.length"
    >
      <button kendoButton themeColor="primary" (click)="onEditClick()">
        Edit
      </button>
    </ng-container>

    <ng-container *ngIf="isEditMode">
      <button kendoButton themeColor="error" (click)="onCancelClick()">
        Cancel
      </button>
      <button kendoButton themeColor="success" (click)="onClickSave()">
        Save
      </button>
    </ng-container>

    <button
      *ngIf="selectedCategory"
      kendoButton
      themeColor="primary"
      icon="plus"
      (click)="onClickAddItems()"
    >
      <fa-icon class="icon-text" [icon]="['fas', 'plus']"></fa-icon>
      Add Items
    </button>
  </div>
</div>

<div class="tab-content-container split-grid">
  <div class="left-panel">
    <app-data-grid
      [mode]="isCategoryEditMode ? 'edit' : 'view'"
      #categoriesGrid
      [dataItems]="categories"
      [columns]="categoryColumns"
      [state]="state"
      [filterable]="'menu'"
      [selectable]="true"
      [paginate]="false"
      (dataStateChange)="onDataStateChanged($event)"
      (rowSelected)="handleRowClick($event)"
      [selectedRow]="selectCategoryRow"
      [hideCommands]="!isCategoryEditMode"
    >
      <ng-template
        commandColumnTemplate
        align="end"
        type="delete"
        [width]="10"
        title=""
        let-dataItem
      >
        <button
          kendoButton
          (click)="onDeleteCategory(dataItem)"
          themeColor="error"
          rounded="full"
          fillMode="flat"
          [disabled]="!isCategoryEditMode"
        >
          <fa-icon
            class="m-r-0"
            [icon]="['fas', 'circle-x']"
            size="sm"
          ></fa-icon>
        </button>
      </ng-template>
      <ng-template
        columnTemplate
        let-row="row"
        field="sortOrder"
        let-column="column"
      >
        <div class="sort-order-controls" *ngIf="isCategoryEditMode">
          <kendo-numerictextbox
            #numericBox
            disableMouseWheel
            [(ngModel)]="row[column.field]"
            [step]="1"
            format="n0"
            [spinners]="false"
            [decimals]="0"
            (focus)="oldValue = row[column.field]"
            (blur)="sortOrderChange(categoriesGrid, row, 'categories')"
            (keydown.enter)="onEnterKey(row, numericBox)"
            (keydown)="blockInvalidKeys($event)"
            [min]="1"
            [max]="categories.total"
          ></kendo-numerictextbox>
          <div>
            <button
              (click)="swapRows(categoriesGrid, row, 'up', 'categories')"
              [disabled]="!isCategoryEditMode"
              title="Move Up"
              class="up-down-arrow"
            >
              &#9650;
            </button>
            <button
              (click)="swapRows(categoriesGrid, row, 'down', 'categories')"
              [disabled]="!isCategoryEditMode"
              title="Move Down"
              class="up-down-arrow"
            >
              &#9660;
            </button>
          </div>
        </div>
        <div *ngIf="!isCategoryEditMode">
          {{ row[column.field] }}
        </div>
      </ng-template>
    </app-data-grid>
  </div>

  <div class="right-panel">
    <app-data-grid
      [mode]="isEditMode ? 'edit' : 'view'"
      #itemGrid
      [isQuickView]="true"
      [dataItems]="assignedItems"
      [columns]="itemColumns"
      [state]="itemState"
      [paginate]="false"
      (dataStateChange)="onDataStateChangedItems($event)"
      [filterable]="'menu'"
      [selectedRow]="selectItemRow"
      [hideCommands]="!isEditMode"
    >
      <ng-template
        commandColumnTemplate
        align="end"
        type="delete"
        [width]="10"
        title="Action"
        let-dataItem
      >
        <button
          kendoButton
          (click)="onClickUnAssign(dataItem)"
          themeColor="error"
          rounded="full"
          fillMode="flat"
          [disabled]="!isEditMode"
        >
          <fa-icon
            class="m-r-0"
            [icon]="['fas', 'circle-x']"
            size="sm"
          ></fa-icon>
        </button>
      </ng-template>
      <ng-template
        columnTemplate
        let-row="row"
        field="sortOrder"
        let-column="column"
      >
        <div class="sort-order-controls" *ngIf="isEditMode">
          <kendo-numerictextbox
            #itemNumericBox
            disableMouseWheel
            [(ngModel)]="row[column.field]"
            [step]="1"
            format="n0"
            [spinners]="false"
            [decimals]="0"
            (blur)="sortOrderChange(itemGrid, row.id, 'items')"
            (keydown.enter)="onKeyEnterItem(row, itemNumericBox)"
            (keydown)="blockInvalidKeys($event)"
            (focus)="oldValue = row[column.field]"
            [min]="1"
            [max]="assignedItems.total"
          >
          </kendo-numerictextbox>

          <div>
            <button
              (click)="swapRows(itemGrid, row, 'up', 'items')"
              [disabled]="!isEditMode"
              title="Move Up"
              class="up-down-arrow"
            >
              &#9650;
            </button>
            <button
              (click)="swapRows(itemGrid, row, 'down', 'items')"
              [disabled]="!isEditMode"
              title="Move Down"
              class="up-down-arrow"
            >
              &#9660;
            </button>
          </div>
        </div>
        <div *ngIf="!isEditMode">
          {{ row[column.field] }}
        </div>
      </ng-template>
    </app-data-grid>
  </div>
</div>

<kendo-dialog
  [width]="700"
  *ngIf="showUnAssignDialog"
  (close)="showUnAssignDialog = false"
>
  <kendo-dialog-titlebar>
    <fa-icon
      class="error-icon"
      [icon]="['fas', 'exclamation-circle']"
    ></fa-icon>
    Un-assign item from category
  </kendo-dialog-titlebar>

  <p>
    <strong>{{ unAssignDialogText }}</strong>
  </p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="showUnAssignDialog = false">No</button>
    <button kendoButton (click)="confirmUnassign()" themeColor="error">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog
  [width]="770"
  [height]="800"
  *ngIf="showAssignDialog"
  (close)="showAssignDialog = false"
>
  <kendo-dialog-titlebar>
    Assign items for {{ selectedCategory?.name }}
  </kendo-dialog-titlebar>
  <app-data-grid
    [mode]="'view'"
    [isQuickView]="true"
    [dataItems]="unAssignedItems"
    [columns]="itemColumns"
    [state]="addItemState"
    (dataStateChange)="onDataStateChangedAddItems($event)"
    [filterable]="'menu'"
  >
    <ng-template
      commandColumnTemplate
      align="end"
      type="edit"
      [width]="10"
      title=""
      let-dataItem
    >
      <kendo-checkbox
        (checkedStateChange)="
          itemsToAssign.has(dataItem.id)
            ? itemsToAssign.delete(dataItem.id)
            : itemsToAssign.add(dataItem.id)
        "
        [checkedState]="itemsToAssign.has(dataItem.id)"
      ></kendo-checkbox>
    </ng-template>
  </app-data-grid>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="showAssignDialog = false">Cancel</button>
    <button kendoButton (click)="confirmAssign()" themeColor="primary">
      Assign Items
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog
  [width]="700"
  *ngIf="showIsActiveCategoryUpdate"
  (close)="closeUpdateCategoryPopup()"
>
  <kendo-dialog-titlebar>
    <fa-icon
      class="error-icon"
      [icon]="['fas', 'exclamation-circle']"
    ></fa-icon>
    Update Category
  </kendo-dialog-titlebar>

  <p>
    <strong>{{ updateCategoryMessage }}</strong>
  </p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeUpdateCategoryPopup()">No</button>
    <button kendoButton (click)="confirmCategoryUpdate()" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [width]="700"
  *ngIf="showSortOrderSavePopup"
  (close)="closeItemUpdatePopup()"
>
  <kendo-dialog-titlebar> Update Sort Order For Items </kendo-dialog-titlebar>
  <p>
    <strong>Do you want to update ?</strong>
  </p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeItemUpdatePopup()">No</button>
    <button kendoButton (click)="SaveItems()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog
  [width]="700"
  *ngIf="showAddCategoryPopup"
  (close)="closeCategoryAddPopup()"
>
  <kendo-dialog-titlebar> Add Category </kendo-dialog-titlebar>
  <p>
    <strong>Category</strong>
  </p>
  <input type="text" kendoTextBox [(ngModel)]="addCategory.name" />
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeCategoryAddPopup()">No</button>
    <button kendoButton (click)="AddCategory()" themeColor="primary">
      Add
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [width]="700"
  *ngIf="showDeleteCategoryPopup"
  (close)="closeCategoryDeletePopup()"
>
  <kendo-dialog-titlebar> Delete Category </kendo-dialog-titlebar>
  <p>
    <strong>Do you want to Delete "{{ selectedCategory?.name }}" ?</strong>
  </p>
  <p>
    <strong>Items Assigned to this Category will be also removed. </strong>
  </p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeCategoryDeletePopup()">No</button>
    <button kendoButton (click)="delteCategory()" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog
  [width]="700"
  *ngIf="showCategorySortOrderSavePopup"
  (close)="closeCategorySortOrderPopup()"
>
  <kendo-dialog-titlebar>
    Update Sort Order For Categories
  </kendo-dialog-titlebar>
  <p>
    <strong>Do you want to update ?</strong>
  </p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeCategorySortOrderPopup()">No</button>
    <button kendoButton (click)="saveCategorySortOrder()" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
